<script lang="ts">
	import { page } from '$app/stores';
	import { locales } from '@riva-mono/common';
	import { goto } from '$app/navigation';
	import Dropdown from './Dropdown.svelte';
	import { PUBLIC_COOKIE_DOMAIN } from '$env/static/public';

	interface Props {
		direction?: string;
	}

	let { direction = 'down' }: Props = $props();

	const supportedLocales = locales.get().map((l) => l.toLowerCase());
	let locale = $derived($page.params.lang);

	const changeLang = (lang: string) => {
		document.cookie = `lang=${lang};path=/;expires=${new Date(Date.now() + 1000 * 60 * 60 * 24 * 365).toUTCString()};domain=${PUBLIC_COOKIE_DOMAIN}`;
		const url = locale ? $page.url.href.replace(locale, lang) : `/${lang}${$page.url.href}`;
		goto(url);
	};
</script>

<Dropdown
	{direction}
	triggerStyle="border-color: rgba(81, 31, 58, 0.1); padding: calc(var(--spacing-s) / 2) 1rem; line-height:1em;"
>
	{locale.toUpperCase()}
	<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.76172 7.05078C5.53125 7.05078 5.32031 6.95703 5.12891 6.76953L0.716797 2.25781C0.642578 2.17969 0.585938 2.0957 0.546875 2.00586C0.511719 1.91602 0.494141 1.81641 0.494141 1.70703C0.494141 1.5625 0.529297 1.42969 0.599609 1.30859C0.669922 1.1875 0.763672 1.0918 0.880859 1.02148C1.00195 0.951172 1.13477 0.916016 1.2793 0.916016C1.49805 0.916016 1.68945 0.996094 1.85352 1.15625L6.03125 5.44531H5.49805L9.66406 1.15625C9.82812 0.996094 10.0195 0.916016 10.2383 0.916016C10.3828 0.916016 10.5137 0.951172 10.6309 1.02148C10.752 1.0918 10.8477 1.1875 10.918 1.30859C10.9883 1.42969 11.0234 1.5625 11.0234 1.70703C11.0234 1.92188 10.9473 2.10352 10.7949 2.25195L6.39453 6.76953C6.30078 6.86328 6.20117 6.93359 6.0957 6.98047C5.99414 7.02344 5.88281 7.04688 5.76172 7.05078Z"
			fill="#511F3A"
		/>
	</svg>
	{#snippet menu()}
		<div>
			{#each supportedLocales as l}
				<button class="button item" onclick={() => changeLang(l)}>{l.toUpperCase()}</button>
			{/each}
		</div>
	{/snippet}
</Dropdown>

<style>
	.item {
		white-space: nowrap;
		font-weight: 500;
		padding: 0.5rem 1rem;
		background: var(--white);
		border: unset;
		text-align: left;
		border-radius: unset;
		width: calc(100% - 0.5rem);
		justify-content: flex-start;
		border-radius: 0.8rem;
		margin: 0 0.25rem;
		font-weight: 700;
	}

	.item:hover {
		background: var(--primary-color-5);
	}
</style>
